import { useTheme } from "@mui/material/styles";

import Icon from "ui/atom/Icon";
import Link from "ui/atom/Link";


export default function Back({ label, to }) {
	const theme = useTheme();
	const style = {
		display: "flex",
		alignItems: "center",
		alignSelf: "flex-start",
		gap: theme.spacing(0.5)
	};

	return (
		<Link variant="caption" fontSize="14px" to={to} sx={style}>
			<Icon name="chevron-left" size={14} />
			{label}
		</Link>
	);
}